module.exports = __webpack_public_path__ + "img/section3_banner2.431178e9.jpg";